import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Input, BaseButton } from 'iebt-zing-storybook'
import { trans } from 'sharedKernel/i18n'
import * as S from './styles'

// Props for the InviteForm component
interface InviteFormProps {
  memberName: string
  emailValue: string
  hasReachedLimit: boolean
  maxMembers: number
  onChangeName: (value: string) => void
  onChangeEmail: (value: string) => void
  onAdd: () => void
}

export const InviteForm = ({
  memberName,
  emailValue,
  hasReachedLimit,
  maxMembers,
  onChangeName,
  onChangeEmail,
  onAdd
}: InviteFormProps): JSX.Element => {
  const disabled = hasReachedLimit || !memberName.trim() || !emailValue.trim()

  return (
    <S.AddMemberWrapper>
      <Row className="align-items-end">
        <Col xs={12} md={5}>
          <Input
            id="memberName"
            isRequired={true}
            value={memberName}
            label={trans('Nome do membro')}
            onChange={(event) => onChangeName(event.target.value)}
          />
        </Col>
        <Col xs={12} md={7}>
          <S.MemberButtonWrapper>
            <div className="member-input">
              <Input
                id="memberEmail"
                isRequired={true}
                value={emailValue}
                label={trans('E-mail do membro')}
                onChange={(event) => onChangeEmail(event.target.value.split(' ').join(''))}
              />
            </div>
            <div className="add-button">
              <BaseButton
                disabled={disabled}
                btnContent={trans('Adicionar')}
                variant="primary"
                size="medium"
                onClick={onAdd}
              />
            </div>
          </S.MemberButtonWrapper>
        </Col>
      </Row>
      
      {hasReachedLimit && (
        <S.LimitMessage>
          <span>Você atingiu o limite máximo de {maxMembers} membros</span>
        </S.LimitMessage>
      )}
    </S.AddMemberWrapper>
  )
}